import React from "react";
import {Box, LinearProgress, TablePagination, useTheme} from "@mui/material";
import {makeRequest} from "../../../services/requestService";
import PropTypes from 'prop-types';
import PivanTable from "./PivanTable";

function PivanTableWithRequest(props) {
    const [page, setPage] = React.useState(0);
    const [data, setData] = React.useState([]);
    const [size, setSize] = React.useState(10);
    const [totalItems, setTotalItems] = React.useState(0);
    const [loading, setLoading] = React.useState(true);
    const theme = useTheme();
    const {
        caption,
        columns,
        url,
        urlAdditionalOption,
        rowsPerPageOptions,
    } = props;

    React.useEffect(() => {
        setLoading(() => {
            setLoading(true);
            let URL = `${url}?page=${page}&size=${size}`;
            if (urlAdditionalOption) {
                URL = `${URL}${urlAdditionalOption}`
            }
            makeRequest(URL).then((response) => {
                if (response.status === 200) {
                    setPage(response.data.currentPage);
                    setData(response.data.data);
                    setTotalItems(response.data.totalItems);
                }
                setTimeout(() => {
                    setLoading(false);
                }, 200);
            });
        });
    }, [page, size, url, urlAdditionalOption]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setLoading(true);
    };

    const handleChangeRowsPerPage = (event) => {
        setSize(+event.target.value);
        setPage(0);
    };

    return (
        <Box sx={{
            borderRadius: '4px',
            bgcolor: theme.palette.mode === 'dark' ? theme => theme.palette.appBar.main : undefined
        }}>
            <PivanTable
                columns={columns}
                rows={data}
                caption={caption}
            />
            <Box mt={1} minHeight={5}>
                {loading && <LinearProgress color="secondary"/>}
            </Box>
            <TablePagination
                rowsPerPageOptions={rowsPerPageOptions}
                component="div"
                count={totalItems}
                rowsPerPage={size}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Box>
    );
}

PivanTableWithRequest.propTypes = {
    caption: PropTypes.string,
    columns: PropTypes.array.isRequired,
    url: PropTypes.string.isRequired,
    urlAdditionalOption: PropTypes.string,
    rowsPerPageOptions: PropTypes.array,
}

PivanTableWithRequest.defaultProps = {
    rowsPerPageOptions: [10, 25, 50, 100]
}

export default PivanTableWithRequest;